<template>
<div class='gPageBorder' v-loading='loading'>

  <el-dialog class='gDia' :title="$t('app_inssuccess')" v-model="pushDone" @open=open @close='close'>
    <p>{{$t('app_isjtoviewtd') + '?'}} </p> 
    <span slot="footer" class="dialog-footer">
      <el-button @click="pushDone = false">{{$t('app_cancel')}}</el-button>
      <el-button type="primary" @click="jumpNow">{{$t('app_nowjump')}}</el-button>
    </span>
  </el-dialog>

      <el-row >
         <el-col :span="4">
           <el-button class='gSgLeftBtn' type="primary" @click="bindAll" >{{$t('lin_btn.batch_install')}}</el-button>
         </el-col>
         <el-col :span="15">
           <div class='gSpDiv'></div>
         </el-col>
         <el-col :span="5">
           <div class='gSideCtrl'>
           <el-input

              :placeholder="$t('terminal.appBind.place_name')"
            icon="search"
            v-model="input"
            :on-icon-click="handleIconClick"
            @keyup.enter.native="focusEvent(handleIconClick)">
            </el-input>
            </div>
          </el-col>
      </el-row>

  <el-table
    class='gTopMg'
    :data="tableData"
    border
    @selection-change="handleSelectionChange"
    v-loading="loading"
    style="width: 100%">
    <el-table-column
      type="selection"
      width="55">
    </el-table-column>
    <el-table-column
      prop="appName"
      :label="$t('terminal.appBind.label_name')">
    </el-table-column>
    <el-table-column
      prop="appVersion"
      :label="$t('terminal.appBind.label_version')">
    </el-table-column>
    <el-table-column
      prop="appSize"
      :label="$t('terminal.appBind.label_size')">
    </el-table-column>
    <!-- <el-table-column
      prop="appDesc"
      label="APP描述"
      width="180">
    </el-table-column>
    <el-table-column
      prop="appUrl"
      label="下载路径"
      width="280">
    </el-table-column> -->
    <el-table-column align='center' width='80' :label="$t('lin_global.ope')">
      <template slot-scope="scope">
       <!-- <el-button
          size="small"
          @click="bind(scope.row.applicationid,scope.row.appUrl,scope.row.appVersion,scope.row.appName, scope.row)">{{$t('lin_btn.install')}}</el-button> -->

          <el-tooltip class="item" effect="dark" :content="$t('lin_btn.install')" placement="top">
            <el-button type='text' @click='bind(scope.row.applicationid,scope.row.appUrl,scope.row.appVersion,scope.row.appName, scope.row)'><i class="fa fa-plus-square" style=""></i></el-button>
          </el-tooltip>
      </template>
    </el-table-column>
  </el-table>

</div>
</template>

<script>
  import axios from 'axios'
  import { baseurl,focusEvent } from '../../api/url'
  export default {
    data() {
      return {
        pushDone: false,
        focusEvent: focusEvent,
        terminalID: this.$route.params.id,
        terminalNO: this.$route.params.no,
        tableData: [],
        input:'',
        rows: [],
        multipleSelection:'',
        multipleSelectionUrl:'',
        multipleSelectionVersions:'',
        multipleSelectionNames:'',
        loading: false,
        tInfo: ''
      }
    },
    created(){ 
      var info = this.$getWObj().terminalInfo
      this.tInfo = info
      
      this.getList()
    },
    methods:{
      jumpNow () {
        this.$router.push({path: '/task/ptask'})
      },
      handleIconClick:function(){
        this.getList()
      },
      bindAll:function(){
          var arr = [];
          arr = this.multipleSelection.split(",");
        if(this.multipleSelection == ''){
            this.$message(this.$t('terminal.appBind.empty_tips'));
        }else if(arr.length>5){
          this.$message(this.$t('terminal.appBind.five_tips'));
        }else{

            this.bind(this.multipleSelection,this.multipleSelectionUrl,this.multipleSelectionVersions,this.multipleSelectionNames);
        }
      },
      handleSelectionChange:function(val){
        //console.log("打印选择的东西");
        //console.log(val);
        let arrId = [];
        let appU = [];
        let appV= [];
        let appN= [];
        for(let i=0;i<val.length;i++){
          let {applicationid} = val[i];
          let {appUrl} = val[i];
          let {appVersion} = val[i];
          let {appName} = val[i];
          arrId.push(applicationid);
          appU.push(appUrl);
          appV.push(appVersion);
          appN.push(appName);
        }
        var strId = arrId.join(",");
        var strUrl = appU.join(",");
        var strVer = appV.join(",");
        var strNam = appV.join(",");
        this.multipleSelection = strId;
        this.multipleSelectionUrl = strUrl;
        this.multipleSelectionVersions = strVer;
        this.multipleSelectionNames = strNam;
        this.rows = val

      },
      bind:function(a,b,c,d,row){

        //var params = {application_id:a,terminal_id:this.terminalID,app_url:b,versions:c,terminalNo:this.terminalNO,terminalName:'',application_name:d};
        //console.log("打印所传参数");
        //console.log(params)

       
        this.$confirm(this.$t('terminal.appBind.install_tips'), this.$t('lin_btn.tips'), {
          confirmButtonText: this.$t('lin_btn.confirm'),
          cancelButtonText: this.$t('lin_btn.cancel'),
          type: 'warning'
        }).then(() => {

          this.loading = true
          this.$terBindApp(a, this.terminalNO, (res) => {
            this.loading = false
            if (res.status == 200) {
              //this.$message.success(this.$t('lin_global.task_tips'));
              //this.$router.go(-1);
              // alert
              this.pushDone = true
              this.getList()
            } else {
              //console.log(res.message)
              this.$message.error(res.message);
             
            }
          }, (error) => {
            this.loading = false
            this.$message.error(this.$t('app_rqsError'))
          })

          /*this.loading = 1
          this.$bindApp1(this.tInfo.mechanismId, this.terminalNO, a, (res) => {
            if (res.status == 200) {
              this.loading = 0
              this.$message.success(this.$t('lin_global.task_tips'));
              this.$router.go(-1);
            } else {
              //console.log(res.message)
              this.$message.error(res.message);
              this.loading = 0
            }
          }, (error) => {
            this.loading = 0
            this.$message.error(this.$t('app_rqsError'))
          })*/

          /*axios.post(`${baseurl}/terminal_app/bind.do`,params).then(res=>{
            //console.log("绑定")
            //console.log(res.data);
            if (res.data.status == 200) {
              this.$message.success(this.$t('lin_global.task_tips'));
              this.$router.go(-1);
            } else {
              //console.log(res.data.message)
              this.$message.error(res.data.message);
            }
          })*/
        }).catch(() => {

        })
      },
      getList:function(){
        var mechanismId = localStorage.getItem('mechanismId');
        // var mechanismId = this.tInfo.mechanismId

        // var params = {distributorId: mechanismId,page:1,rows:10000,terminalId:this.terminalID,appName:this.input};
        //var info = this.$store.getters.ter_param.ter
        //console.log('info', info)


        this.$getTerInstallList(1, 10000, mechanismId, this.input, this.terminalID, (res) => {
          //console.log("打印列表")
          //console.log(res.data.data)
          if(res.status == 200){
            this.tableData = res.data;
            this.loading = false;
          }else{
            this.loading = false;
          }
        }, (error) => {

        })
        /*axios.post(`${baseurl}/appDistribute/getTerminalAppList.do`,params).then(res=>{
          //console.log("打印列表")
          //console.log(res.data.data)
          if(res.data.status == 200){
            this.tableData = res.data.data;
            this.loading = false;
          }else{
            this.loading = false;
          }

        })*/
      }
    }
  }
</script>



// WEBPACK FOOTER //
// appBind.vue?4065cc2e